import { AbstractCommand } from "@astina/paloma-common-ui/src/services/CommandQueue";
import vensoRepository from "@/services/VensoRepository";
import alerts from "@astina/paloma-common-ui/src/services/Alerts";
import trans from "@astina/paloma-common-ui/src/services/Translator";
export function addDeliveryNoticeItem(groupId, accessToken, update) {
    return new AddDeliveryNoticeItem(groupId, accessToken, update)
        .enqueue();
}
export default class AddDeliveryNoticeItem extends AbstractCommand {
    groupId;
    accessToken;
    draft;
    constructor(groupId, accessToken, draft) {
        super();
        this.groupId = groupId;
        this.accessToken = accessToken;
        this.draft = draft;
    }
    async execute() {
        try {
            return await vensoRepository.addDeliveryNoticeItem(this.groupId, this.accessToken, this.draft);
        }
        catch (e) {
            alerts.error(trans(`${this.name()}.error`));
            throw e;
        }
    }
    name() {
        return 'add_delivery_notice_item';
    }
}
